import { ToastController } from '@ionic/angular';
import { RegisterResetpassService } from 'src/app/services/register-resetpass/register-resetpass.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage implements OnInit {
  resetPasswordForm: FormGroup;
  isLoading$: Observable<boolean>;

  response_message: string = '';

  constructor(
    private router: Router,
    public auth: AuthService,
    private fb: FormBuilder,
    private register_resetpass: RegisterResetpassService,
    private toast: ToastController
  ) {}

  get email() {
    return this.resetPasswordForm.get('email');
  }

  goToLogin() {
    this.router.navigate(['login']);
  }

  async resetPassword() {
    var email = this.resetPasswordForm.value;
    await this.auth.reset_password(email);

    if(this.auth.fb_reset_error){
      this.response_message = this.auth.fb_reset_error;
      console.log(this.auth.fb_reset_error);
      this.presentErrorToast(this.response_message);
    } else {
      this.response_message = "Email sent successfully";
      this.presentSuccessToast(this.response_message);
    }
    // this.register_resetpass.resetPassword(email).subscribe((res) => {
    //   if (res.error) {
    //     this.isFBError = true;
    //     this.fb_error = res.error;
    //   } else {
    //     this.isFBError = false;
    //     this.fb_success = "Email sent";
    //   }
    // });
  }

  async resendEmail() {
    var email = this.resetPasswordForm.value;
    await this.auth.reset_password(email);

    if(this.auth.fb_reset_error){
      this.response_message = this.auth.fb_reset_error;
      this.presentErrorToast(this.response_message);
    } else {
      this.response_message = "Email sent again successfully";
      this.presentSuccessToast(this.response_message);
    }
  }

  ngOnInit() {
    this.resetPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern('^[^@]+@([-\\w]+\\.)+[A-Za-z]{2,4}$')]],
    });

    this.isLoading$ = this.auth.isLoading$;
  }


  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      // header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

}
